import Upload from '@/components/Upload';
import { FileUploadData } from '@/hooks/upload/FileUpload';
import { ApplicationState } from '@/store';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

interface Props {
    path: string;
    onChange: (fieldName: string, value: string | null, index?: number) => void;
}

const LessonCardDocument: React.FC<Props> = ({ path, onChange }) => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);

    const previewFile = useMemo(() => ({ uri: path, name: path }), [path]);

    const completeUpload = useCallback((response: FileUploadData): void => {
        onChange('path', response.key);
    }, []);

    const removeUpload = useCallback((): void => {
        onChange('path', null);
    }, []);

    return (
        <div className="input-section">
            <h1>{strings.DOCUMENT}</h1>
            <Upload onComplete={completeUpload} onRemove={removeUpload} previewFile={previewFile} typeAccepted="DOCUMENT" />
        </div>
    );
};

export default LessonCardDocument;
